module.exports = __webpack_public_path__ + "img/vertical_7_5_2.c5fedd3e.png";